import { render } from "./AccountDeleteComplete.vue?vue&type=template&id=0b183fea"
import script from "./AccountDeleteComplete.vue?vue&type=script&lang=js"
export * from "./AccountDeleteComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__